import{a as n}from"./chunk-RAAYCPUM.js";function t(...a){return n(e,a)}var e=(a,o)=>o.every(l=>l(a));export{t as a};
